/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Directive, ElementRef } from '@angular/core';

@Directive({ selector: '[orbitAsideHeader]', standalone: false })
export class OrbitAsideHeaderDirective {}

@Directive({ selector: '[orbitAsideBody]', standalone: false })
export class OrbitAsideBodyDirective {}

@Directive({ selector: '[orbitAsideFooter]', standalone: false })
export class OrbitAsideFooterDirective {
	constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

	hasOutcomeActions(): boolean {
		return !!this.elementRef.nativeElement.querySelector(
			'button, input[type="submit"], input[type="button"], [role="button"], a[href]',
		);
	}
}
